import { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import styles from '../assets/styles/pages/Expiration.module.scss';
import { FixedSpace } from '../components/FixedSpace';
import { Sidebar } from '../components/Sidebar';
import { Texts } from '../constants/Texts';
import { useCustomerContext } from '../context/Customer';
import * as routes from '../routing/routes';

export const Expiration = () => {
  const navigate = useNavigate();
  const customerContext = useCustomerContext();
  const restart = () => {
    customerContext.setCurrentPosition(routes.home);
    customerContext.restart();
  };
  const { pathname } = useLocation();

  useEffect(() => {
    if (pathname != customerContext.currentPosition) {
      customerContext.setCurrentPosition(routes.home);
      navigate(routes.home);
    }
  }, [pathname]);

  useEffect(() => {
    if (customerContext.currentPosition != routes.expiration) navigate(customerContext.currentPosition!);
  }, [customerContext.currentPosition]);

  return (
    <div className={styles.main}>
      <Sidebar firstHeader={Texts.ENTER_PASSWORD} secondHeader={Texts.PROTEXTION_CERTIFICATES} />
      <div className={styles.container}>
        <div className={styles.ops}>{Texts.OPS}</div>
        <div className={styles.message}>{Texts.EXPIRED}</div>
        <div className={styles.message}>{Texts.RESTART}</div>
        <FixedSpace height={'7.6rem'} />
        <div className={styles.btn}>
          <button onClick={restart} className={styles.restartBtn}>
            {Texts.START_AGAIN}
          </button>
        </div>
      </div>
    </div>
  );
};
